import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, useParameters } from '@web/utils';
import { useAppSelector } from '@/store/hooks';
import { selectCartHasItems, selectCartLength } from '@agrantis/cart/selectors';

interface CartRouteParameters {
  retailerId: string;
}

const HeaderCartButton = () => {
  const { retailerId } = useParameters<CartRouteParameters>();
  const cartHasItems = useAppSelector(selectCartHasItems(retailerId));
  const numberOfCartItems = useAppSelector(selectCartLength(retailerId));
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const isCheckoutPage = location.pathname.includes('/checkout');

  const handleNavigation = () => {
    if (isCheckoutPage) {
      navigate(`/${retailerId}`);
    } else {
      navigate(`/${retailerId}/checkout`);
    }
  };

  return (
    <div>
      {(cartHasItems || isCheckoutPage) && (
        <Button
          disabled={!cartHasItems && !isCheckoutPage}
          variant="secondary"
          className="relative flex items-center ml-auto m-2-0 hover:opacity-50"
          onClick={handleNavigation}
        >
          <span>
            {isCheckoutPage
              ? t('checkout.back_to_shop')
              : t('checkout.go_to_checkout')}
          </span>
          {!isCheckoutPage && numberOfCartItems > 0 && (
            <span className="inline-flex items-center justify-center text-xs font-bold leading-none text-white rounded-full py-1-0 px-0-7 ml-1-0 bg-primary-green">
              {numberOfCartItems}
            </span>
          )}
        </Button>
      )}
    </div>
  );
};

export default HeaderCartButton;
